if (!rtAPI) var rtAPI = {};
if (!rtAPI.security) rtAPI.security = {};

//#region Login Steps

rtAPI.security.handle.login = async function (event) {
    event.preventDefault();
    rtAPI.messages.clear();
    var login = rtAPI.security.fd.login.value;
    var password = rtAPI.security.fd.password.value;
    var manageTFA = rtAPI.security.enableTFAManagement ? rtAPI.security.fd.manageTFA.checked : false;
    if (!rtAPI.validateRequired('requiredGroupLogin') || login == '' || password == '') return;
    result = await rtAPI.security.call.login(login, password, rtAPI.security.samePageLogin, manageTFA)
    if (result.statusOk) {
        rtAPI.security.fireTFAHardwareKeyLoginWhenSelected = true;
        rtAPI.security.showTFAManagement = rtAPI.security.fd.manageTFA.checked;
        if (result.isLoggedIn) rtAPI.security.clearFields();
        rtAPI.resetRequired();
    }
    rtAPI.security.updatePanels(result)
}

rtAPI.security.handle.loginSSO = async function (event) {
    event.preventDefault();
    rtAPI.messages.clear();
    result = await rtAPI.security.call.loginSSO(rtAPI.security.samePageLogin)
    if (result.statusOk) {
        if (result.isLoggedIn) rtAPI.security.clearFields();
        rtAPI.resetRequired();
    }
    rtAPI.security.updatePanels(result)
}

rtAPI.security.handle.showLostPassword = function (event) {
    event.preventDefault();
    rtAPI.displayElement(rtAPI.security.pnl.login, false);
    rtAPI.displayElement(rtAPI.security.pnl.lostPassword, true);
    rtAPI.messages.clear();
    rtAPI.resetRequired();
}

rtAPI.security.handle.getLostPassword = function (event) {
    event.preventDefault();
    var userName = rtAPI.security.fd.loginLost.value;
    if (!rtAPI.validateRequired('requiredGroupLostPassword') || userName == '') return;
    rtAPI.security.call.getLostPassword(userName)
    rtAPI.security.handle.showLoginPanel(event)
}

rtAPI.security.handle.showLostUsername = function (event) {
    event.preventDefault();
    rtAPI.displayElement(rtAPI.security.pnl.login, false);
    rtAPI.displayElement(rtAPI.security.pnl.lostUsername, true);
    rtAPI.messages.clear();
    rtAPI.resetRequired();
}

rtAPI.security.handle.getLostUsername = function (event) {
    event.preventDefault();
    var email = rtAPI.security.fd.loginLostEmail.value;
    if (!rtAPI.validateRequired('requiredGroupLostUsername') || email == '') return;
    rtAPI.security.call.getLostUsername(email)
    rtAPI.security.handle.showLoginPanel(event)
}

rtAPI.security.handle.showResendAuthEmail = function (event) {
    event.preventDefault();
    rtAPI.displayElement(rtAPI.security.pnl.login, false);
    rtAPI.displayElement(rtAPI.security.pnl.resendAuthEmail, true);
    rtAPI.messages.clear();
    rtAPI.resetRequired();
}

rtAPI.security.handle.resendAuthEmailSend = function (event) {
    event.preventDefault();
    var userName = rtAPI.security.fd.resendAuthEmail.value;
    if (!rtAPI.validateRequired('requiredGroupResendAuthEmail') || userName == '') return;
    rtAPI.security.call.resendAuthEmail(userName)
    rtAPI.security.handle.showLoginPanel(event)
}

rtAPI.security.handle.showLoginPanel = function (event) {
    event.preventDefault();
    rtAPI.displayElement(rtAPI.security.pnl.login, true);
    rtAPI.displayElement(rtAPI.security.pnl.lostPassword, false);
    rtAPI.displayElement(rtAPI.security.pnl.lostUsername, false);
    rtAPI.displayElement(rtAPI.security.pnl.resendAuthEmail, false);
    rtAPI.security.fd.loginLost.value = '';
    rtAPI.security.fd.resendAuthEmail.value = '';
    rtAPI.messages.clear();
    rtAPI.resetRequired();
}

//#endregion

//#region Logout

rtAPI.security.handle.logout = async function (event) {
    event.preventDefault();
    result = await rtAPI.security.call.logout()
    rtAPI.security.clearFields();
    rtAPI.security.updatePanels(result);
    rtAPI.resetRequired();
}

//#endregion

//#region 2FA - Respond

rtAPI.security.handle.sendSelect2FAMethod = async function (event) {
    var selectedMethod = document.querySelector('input[name="tFAOptions"]:checked').value;
    let result = await rtAPI.security.call.sendSelectedMethod(selectedMethod)
    rtAPI.security.updatePanels(result);
}

rtAPI.security.handle.tFAAuthenticateCodeSend = async function (event) {
    event.preventDefault();
    var authCode = rtAPI.security.fd.authenticationCode.value;
    if (!rtAPI.validateRequired('requiredGroupAuthCode') || authCode == '') return;
    result = await rtAPI.security.call.sendAuthCode(authCode)
    if (result.statusOk) rtAPI.resetRequired();
    rtAPI.security.updatePanels(result);
}

rtAPI.security.handle.tFAMemorableDataSend = async function (event) {
    event.preventDefault();
    var memorableData1 = document.getElementById('memorableData1').value;
    var memorableData2 = document.getElementById('memorableData2').value;
    var memorableData3 = document.getElementById('memorableData3').value;
    if (!rtAPI.validateRequired('requiredGroupMemorableData') || memorableData1 == '' || memorableData2 == '' || memorableData3 == '') return;
    result = await rtAPI.security.call.sendMemorableData(memorableData1, memorableData2, memorableData3)
    if (result.statusOk) rtAPI.resetRequired();
    rtAPI.security.updatePanels(result);
}

rtAPI.security.handle.tFAHardwareKeyRegister = async function (event) {
    event.preventDefault();
    let hardwareKeyResult = await rtAPI.security.hardwareKey.registrationStep1();
    if (!hardwareKeyResult) {
        //rtAPI.security.tFAManageUpdateMessagesUpdate();
        return;
    };
    let result = await rtAPI.security.call.getCurrentUser()
    rtAPI.security.updateManageHardwareKeyPanels(result);
    Swal.fire({
        title: rtAPI.security.tFAData.text.registeredNewHardwareKeyTitle,
        text: rtAPI.security.tFAData.text.registeredNewHardwareKeyText,
        imageUrl: "/resources/securitykey.min.svg",
        showCancelButton: false,
        showConfirmButton: true,
        focusConfirm: true,
        focusCancel: false
    });
}

rtAPI.security.handle.tFAHardwareKeyRetry = async function (event) {
    event.preventDefault();
    await rtAPI.security.hardwareKey.triggerLogin()
}

rtAPI.security.handle.tFAAuthenticateCancel = async function (event) {
    event.preventDefault();
    result = await rtAPI.security.call.cancelTFA()
    rtAPI.security.updatePanels(result);
    rtAPI.resetRequired();
}

//#endregion

//#region 2FA Manage

rtAPI.security.handle.showMFM = async function (event) {
    event.preventDefault();
    let result = await rtAPI.security.call.getCurrentUser()
    if (!result.isLoggedIn) {
        rtAPI.loadingPanel.show();
        document.location.reload();
        return;
    };
    rtAPI.security.showTFAManagement = true;
    rtAPI.security.updatePanels(result);
}

rtAPI.security.handle.tFAManageUpdate = async function (event) {
    //debugger;
    event.preventDefault();
    //rtAPI.security.tFAData.password.value = rtAPI.security.fd.tFAUpdatePassword.value;
    //rtAPI.security.tFAManageUpdateMessagesClear();
    rtAPI.messages.clear();
    if (rtAPI.security.tFAManageOptionsAreValid()) {
        let hardwareKeyOption = rtAPI.security.get2FAOption('HardwareKey');
        if (hardwareKeyOption.enabled != hardwareKeyOption.newState && hardwareKeyOption.newState) {
            let hardwareKeyResult = await rtAPI.security.hardwareKey.registrationStep1();
            if (!hardwareKeyResult) {
                //rtAPI.security.tFAManageUpdateMessagesUpdate();
                rtAPI.messages.displayAddedMessages();
                return;
            };
        }
        result = await rtAPI.security.call.tFAManageOptionsUpdate(rtAPI.security.tFAData)
        if (result.statusOk) {
            if (result.tFAData.updateStatusOk) {
                rtAPI.security.tFAData = result.tFAData;
            }
            //else {
            //    rtAPI.security.tFAManageUpdateMessagesSet(result);
            //}
        }
        rtAPI.security.update2FAManagePanel();
    }
    rtAPI.messages.displayAddedMessages();
    //rtAPI.security.tFAManageUpdateMessagesUpdate();
}

rtAPI.security.handle.tFAManageOptionToggle = function (event) {
    var option = rtAPI.security.get2FAOption(this.value);
    option.newState = this.checked;

    if (!option.newState) {
        for (const field of option.fields) {
            field.value = field.initialValue;
        }
    }
    rtAPI.security.update2FAManagePanel();
    rtAPI.messages.clear();
}

rtAPI.security.handle.tFAManageFieldInput = function (event) {
    event.preventDefault();
    rtAPI.security.get2FAOptionField(this.id).value = this.value;
    rtAPI.security.update2FAManagePanel();
}

rtAPI.security.handle.tFAManageOptionHardwareKey = function (event) {
    event.preventDefault();
    rtAPI.security.pnl.dialogFields.innerHTML = '';
    rtAPI.security.init2FAManageHardwareKeyPanel();
}

rtAPI.security.handle.tFAManageOptionDeviceAuthentication = function (event) {
    event.preventDefault();
    rtAPI.security.pnl.dialogFields.innerHTML = '';
    rtAPI.security.init2FAManageAuthorisedDevicePanel();
}

rtAPI.security.handle.tFAManageHardwareKeyAdd = async function (event) {
    event.preventDefault();
    let hardwareKeyResult = await rtAPI.security.hardwareKey.registrationStep1();
    if (!hardwareKeyResult) {
        //rtAPI.security.tFAManageUpdateMessagesUpdate();
        return;
    };
    let result = await rtAPI.security.call.getCurrentUser()
    rtAPI.security.updateManageHardwareKeyPanels(result);
}

rtAPI.security.handle.tFAManageHardwareKeyRemove = async function (event) {
    event.preventDefault();
    const swalResult = await Swal.fire({
        title: rtAPI.security.tFAData.text.removeHardwareKeyTitle.replace('{0}', this.userIdent),
        text: rtAPI.security.tFAData.text.removeHardwareKeyText,
        icon: 'error',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        confirmButtonText: 'Remove',
        focusCancel: true,
        width: '450px'
    })
    if (swalResult.isDismissed) return;

    let result = await rtAPI.security.call.registrationRemove(this.idDB);
    rtAPI.security.updateManageHardwareKeyPanels(result);
}

rtAPI.security.handle.tFAManageHardwareKeyAuthorise = async function (event) {
    event.preventDefault();
    const swalResult = await Swal.fire({
        title: rtAPI.security.tFAData.text.authoriseHardwareKeyTitle.replace('{0}', this.userIdent),
        text: rtAPI.security.tFAData.text.authoriseHardwareKeyText,
        icon: 'error',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        confirmButtonText: 'Authorise',
        focusCancel: true,
        width: '450px'
    })
    if (swalResult.isDismissed) return;

    let result = await rtAPI.security.call.registrationAuthorise(this.idDB);
    rtAPI.security.updateManageHardwareKeyPanels(result);
}

rtAPI.security.handle.tFAManageAuthorisedDeviceRemove = async function (event) {
    event.preventDefault();
    const swalResult = await Swal.fire({
        title: rtAPI.security.tFAData.text.removeDeviceTitle.replace('{0}', this.name),
        text: rtAPI.security.tFAData.text.removeDeviceText,
        icon: 'error',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        confirmButtonText: 'Remove',
        focusCancel: true,
        width: '450px'
    })
    if (swalResult.isDismissed) return;

    let result = await rtAPI.security.call.authorisedDeviceRemove(this.idDB);
    rtAPI.security.updateManageAuthorisedDevicePanels(result);
}

rtAPI.security.handle.tFAManageAuthorisedDeviceAuthorise = async function (event) {
    event.preventDefault();
    const swalResult = await Swal.fire({
        title: rtAPI.security.tFAData.text.authoriseDeviceTitle.replace('{0}', this.name),
        text: rtAPI.security.tFAData.text.authoriseDeviceText,
        icon: 'error',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        confirmButtonText: 'Approve',
        focusCancel: true,
        width: '450px'
    })
    if (swalResult.isDismissed) return;

    let result = await rtAPI.security.call.authorisedDeviceAuthorise(this.idDB);
    rtAPI.security.updateManageAuthorisedDevicePanels(result);
}

rtAPI.security.handle.tFAManageBack = function (event) {
    event.preventDefault();
    rtAPI.security.init2FAManagePanel();
}

rtAPI.security.handle.tFAManageAutoClose = function (event) {
    rtAPI.security.pnl.dialog.style.cursor = null;
    rtAPI.security.pnl.dialog.removeAttribute("onclick");
    rtAPI.security.handle.tFAManageCloseCommon(event);
}

rtAPI.security.handle.tFAManageClose = async function (event) {
    rtAPI.security.handle.tFAManageCloseCommon(event);
    rtAPI.security.call.tFAManageOptionsClose();
    if (rtAPI.security.changePasswordMode == 'force' || rtAPI.security.changePasswordMode == 'recover') result = await rtAPI.security.call.logout()
    else result = await rtAPI.security.call.getCurrentUser()
    rtAPI.security.updatePanels(result);
}

rtAPI.security.handle.tFAManageCloseCommon = function (event) {
    event.preventDefault();
    rtAPI.security.showTFAManagement = false;
    rtAPI.security.hideSecurityDialog();
}

//#endregion

//#region Hardware Key

//#endregion

//#region Update Password

rtAPI.security.handle.showUpdatePassword = async function (event) {
    event.preventDefault();
    //debugger;
    let result = await rtAPI.security.call.getCurrentUser()
    rtAPI.security.tFAData = result.tFAData;
    if (!result.isLoggedIn) {
        rtAPI.loadingPanel.show();
        document.location.reload();
        return;
    };

    await rtAPI.security.initUpdatePasswordPanel();
    rtAPI.security.openSecurityDialog(600, 400);
}

rtAPI.security.handle.showMustChangePassword = async function () {
    //debugger;
    let result = await rtAPI.security.call.getCurrentUser()
    rtAPI.security.tFAData = result.tFAData;
    if (!result.mustChangePassword) return;

    await rtAPI.security.initMustChangePassword();
    rtAPI.security.openSecurityDialog(600, 400);
}

rtAPI.security.handle.initRecoverPassword = async function () {
    //debugger;
    let result = await rtAPI.security.call.getCurrentUser()
    rtAPI.security.tFAData = result.tFAData;
    if (!result.recoverPassword) return;

    await rtAPI.security.initRecoverPassword();
    rtAPI.security.openSecurityDialog(600, 400);
}

rtAPI.security.handle.updatePassword = async function (event) {
    //debugger;
    event.preventDefault();
    let result = await rtAPI.security.call.getCurrentUser()
    rtAPI.security.tFAData = result.tFAData;
    if (!result.isLoggedIn && !result.mustChangePassword && !result.recoverPassword) return;

    rtAPI.security.fd.retypeNewPassword.setCustomValidity('');
    rtAPI.messages.clear();

    var oldPassword = 'password';
    if (rtAPI.security.changePasswordMode != 'recover') oldPassword = rtAPI.security.fd.oldPassword.value;
    var newPassword = rtAPI.security.fd.newPassword.value;
    var retypeNewPassword = rtAPI.security.fd.retypeNewPassword.value;
    if (!rtAPI.validateRequired('requiredGroupUpdatePassword') || oldPassword == '' || newPassword == '') return;
    //debugger;
    if (newPassword != retypeNewPassword) {
        rtAPI.security.fd.retypeNewPassword.setCustomValidity(rtAPI.security.errorMessage.retypeNewPassword);
        rtAPI.messages.showCritical(rtAPI.security.errorMessage.retypeNewPassword);
        return;
    }
    if (!rtAPI.security.fd.newPassword.isValidPassword) {
        rtAPI.security.fd.newPassword.setCustomValidity(rtAPI.security.errorMessage.weakPassword);
        rtAPI.messages.showCritical(rtAPI.security.errorMessage.weakPassword);
        return;
    }
    //debugger;
    if (rtAPI.security.changePasswordMode == 'recover') {
        var fdUsername = rtAPI.query.params.get('fdUsername');
        var fdTemporaryPassword = rtAPI.query.params.get('fdTemporaryPassword');
        if (rtAPI.isEmptyString(fdUsername)) return;
        if (rtAPI.isEmptyString(fdTemporaryPassword)) return;
        result = await rtAPI.security.call.recoverPassword(fdUsername, fdTemporaryPassword, newPassword, retypeNewPassword)
    }
    else {
        result = await rtAPI.security.call.updatePassword(oldPassword, newPassword, retypeNewPassword)
    }
    //debugger;
    if (result.statusOk) {
        //if (!result.recoverPassword && !result.mustChangePassword && result.recordActionStatus !="none") {
        //    result = await rtAPI.security.call.logout();
        //    rtAPI.loadingPanel.show();
        //    document.location.reload();
        //    return;
        //};
        if (result.passwordUpdated) {
            rtAPI.displayElement(rtAPI.security.btn.updatePassword, false);
            rtAPI.security.fd.oldPassword.value = '';
            rtAPI.security.fd.newPassword.value = '';
            rtAPI.security.fd.retypeNewPassword.value = '';
            rtAPI.resetRequired();
            rtAPI.security.handle.inputPasswordField(rtAPI.security.fd.newPassword);
            rtAPI.security.showDefaultSecurityDialogButtons(false, true);
            if (rtAPI.security.changePasswordMode != 'user') {//Required for force change password eg. Password recovery
                rtAPI.messages.save();
                result = await rtAPI.security.call.getCurrentUser()
                rtAPI.security.updatePanels(result);
                rtAPI.security.hideSecurityDialog(true);
                rtAPI.messages.restore();
            }
        }
        else {
            //if (rtAPI.security.changePasswordMode != 'user' && !result.passwordHasAlreadyBeenUsed) {//Required for force change password eg. Password recovery 
            //    result = await rtAPI.security.call.logout();
            //    rtAPI.security.clearFields();
            //    pass_chkPass('', rtAPI.security.fd.newPassword.id);
            //    rtAPI.security.updatePanels(result);
            //    rtAPI.resetRequired();
            //}
        }
    }
}

rtAPI.security.handle.inputPasswordField = function (event) {
    //debugger;
    var pwd = event.value;
    var id = event.id;
    event.isValidPassword = pass_chkPass(pwd, id);
}
//#endregion
